import { useContext } from 'react'
import { RecaptchaContext } from 'src/recaptcha/RecaptchaProvider'
import { useCallback } from '.'

export function useRecaptcha(isDisabled: boolean) {
  const { isReady, siteKey } = useContext(RecaptchaContext)

  const getToken = useCallback(
    async (action: string): Promise<string | null> => {
      if (isDisabled) {
        return null
      }
      if (!isReady || !siteKey || !window.grecaptcha?.enterprise) {
        console.warn('reCAPTCHA not ready or missing site key')
        return null
      }
      try {
        await new Promise<void>(resolve => {
          window.grecaptcha.enterprise.ready(resolve)
        })
        const token = await window.grecaptcha.enterprise.execute(siteKey, {
          action,
        })
        return token
      } catch (err) {
        console.error('reCAPTCHA error', err)
        return null
      }
    },
    [isDisabled, isReady, siteKey],
  )
  return { getToken }
}
